module.exports = __webpack_public_path__ + "368fd7010b97aefec3853168ea5ea3b5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-18.svg
// module id = 565
// module chunks = 0